import React from 'react';
import { array } from 'prop-types';

import { connect } from 'react-redux';

import MaterialTable from 'material-table';

import classes from './ProfileTable.module.css';

const ProfileObjectTable = ({
    targetProfileObjects,
    ...props
}) => {

    return (
        <div className={classes.ProfileTable}>
            <div className={classes.title}>
                <h2>Available Profile Objects</h2>
            </div>
            <div className={classes.tableContainer}>
                <MaterialTable
                    options={{
                        paging:    false,
                        showTitle: false,
                        search:    false,
                        selection: false,
                        toolbar:   false,
                        filtering: true
                    }}
                    columns={[
                        { title: 'Object Name', field: 'name' },
                        { title: 'Object Type', field: 'objectType' }
                    ]}
                    data={targetProfileObjects}
                />
            </div>
        </div>
    );
};

ProfileObjectTable.defaultProps = {
    targetProfileObjects: []
};

ProfileObjectTable.propTypes = {
    targetProfileObjects: array
};

const mapStateToProps = state => {
    return {
        targetProfileObjects: state.wizard.targetProfileObjects
    };
};

export default connect(mapStateToProps, null)(ProfileObjectTable);
